import React from "react";
import { Redirect, Route } from "react-router-dom";
import InPlayer from "../backend/inplayer";
import Global from "../../global";
import Cookies from "js-cookie";

const UnFreeRoute = ({ component: Component, ...rest }) => {
  const phone_verifed = Cookies.get("sm_ott_val") === "true";

  // Add your own authentication on the below line.

  return (
    <Route
      {...rest}
      render={(props) =>
        InPlayer.Account.isAuthenticated() ? (
          !phone_verifed &&
          Global.OTP &&
          props.location.pathname !==
            "/" + props.match.params.AppId + "/verify" &&
          props.location.pathname !==
            "/" + props.match.params.AppId + "/sendotp" ? (
            <Redirect
              to={{
                pathname: "/" + props.match.params.AppId + "/sendotp",
                state: { from: props.location },
              }}
            />
          ) : (
            <Component {...props} />
          )
        ) : (
          <Redirect
            to={{
              pathname: "/" + props.match.params.AppId + "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default UnFreeRoute;
